<script>
    import { _ } from 'svelte-i18n';
    import muscles from '../muscles.json';

    export let muscleGroupType;
    
</script>

<style>

    table {
        max-width: 1000px;
        margin: var(--spacingXLarge) auto var(--spacingXXXLarge);
        border-spacing: 0;
    }
    th, td {
        padding: var(--spacingSmall);
        text-align: left;
    }

    td {
        vertical-align: top;
    }

    td.first-col {
        background-color: var(--colorBg);
        font-weight: 800;
        width: 20%;
    }

    td.second-col {
        width: 25%;
    }

    td.third-col {
        width: 20%;
    }

    td.fourth-col, td.fifth-col {
        width: 15%;
    }

    td span {
        display: block;
    }

    .pos-main {
        margin-bottom: var(--spacingSmall);
    }

    .separator td {
        background-color: var(--colorElementOpaque);
        border: 2px solid white;
        padding: 0;
    }

    .separator td > div {
        height: 2px;
    }

    td img {
        width: 100px;
        height: 100px;
    }

    .separator td.first-separator {
        background-color: var(--colorBg);
    }
</style>
<table>
    <tr>
        <th></th>
        <th>{$_('learn.table.th_position')}</th>
        <th>{$_('learn.table.th_stabilization')}</th>
        <th>{$_('learn.table.th_resistance')}</th>
        <th>{$_('learn.table.th_lever')}</th>
    </tr>
    <tr class="separator">
        <td colspan="1" class="first-separator"><div></div></td>
        <td colspan="4"><div></div></td>
    </tr>
    {#each muscles as muscle}
        {#if muscleGroupType == muscle.type}
            <tr>
                <td class="pos-name first-col">{$_('calculator.muscles.' + muscle.name)}</td>
                <td class="second-col"></td>
                <td class="third-col"></td>
                <td class="fourth-col"></td>
                <td class="fifth-col"></td>
            </tr>
            <tr>
                <td class="pos-img first-col">
                    <img src="img/positions_bg/{muscle.img}" alt="{$_('calculator.form.position_alt') + ' ' + $_('calculator.muscles.' + muscle.name)}" />
                </td>
                <td class="second-col">
                    <span class="pos-main">{$_('learn.table.position_main.' + muscle.position_main)}</span>
                    {#each muscle.position_sub as muscle_pos_sub}
                        <span>&#8226; {$_('learn.table.position_sub.' + muscle_pos_sub)}</span>
                    {/each}
                    </td>
                <td class="third-col">
                    {#if muscle.stable != ""}
                        {$_('learn.table.stable.' + muscle.stable)}
                    {/if}
                </td>
                <td class="fourth-col">{$_('learn.table.resistance.' + muscle.resistance)}
                </td>
                <td class="fifth-col">{$_('learn.table.lever.' + muscle.lever)}</td>
            </tr>
            <tr class="separator">
                <td colspan="1" class="first-separator"><div></div></td>
                <td colspan="4"><div></div></td>
            </tr>
        {/if}
    {/each}
</table>
